import { useMemo } from 'react';

import { MantineSize, Text, TextProps, Tooltip } from '@mantine/core';
import classNames from 'classnames';

import styles from './TextWrapper.module.scss';

export interface TextWrapperProps extends TextProps {
  text: string | React.ReactNode;
  variant?: 'normal' | 'heading';
  truncate?: boolean;
  showTooltip?: boolean;
  className?: string;
  size?: MantineSize;
}

const TextWrapper = ({
  text,
  variant = 'normal',
  truncate = false,
  showTooltip = false,
  className,
  size,
  ...rest
}: TextWrapperProps) => {
  const textClasses = useMemo(
    () =>
      classNames(
        styles.text,
        {
          [styles.heading]: variant === 'heading',
          [styles.truncate]: truncate
        },
        className
      ),
    [className, truncate, variant]
  );

  return (
    <Text className={textClasses} size={size ?? (variant === 'heading' ? 'lg' : 'md')} {...rest}>
      {showTooltip ? (
        <Tooltip label={text} position={'top-start'}>
          <span>{text}</span>
        </Tooltip>
      ) : (
        <span>{text}</span>
      )}
    </Text>
  );
};

export default TextWrapper;
